import React from 'react';
import { Dismiss20Regular } from '@fluentui/react-icons';
import { OverlayDrawer } from '@fluentui/react-components';
import { toast } from 'react-toastify';
import styles from './StandardOverview.module.css';
import { OverviewTextAction } from './OverviewCardShell';
import { OVERVIEW_DUMMY_FIELDS } from './overviewDummyFields';
import FileViewerModal from '../../Dataroom2.0/FileViewerModal';

const SourceMaterialsCard = ({ model }) => {
    const { sourceMaterials } = model;
    const files = Array.isArray(sourceMaterials) ? sourceMaterials : [];
    const count = files.length;
    const [listOpen, setListOpen] = React.useState(false);
    const [viewerOpen, setViewerOpen] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [selectedFileIndex, setSelectedFileIndex] = React.useState(0);

    const previewNames = files
        .slice(0, 3)
        .map(file => file.document_name)
        .filter(Boolean)
        .join(' · ');

    const openFile = (file, index) => {
        if (!file?.document) {
            toast.error('This file cannot be previewed.');
            return;
        }
        setSelectedFileIndex(index);
        setSelectedFile({
            id: file.id,
            document_name: file.document_name,
            document: file.document,
            extension: file.extension,
            filePath: file.document_name,
        });
        setViewerOpen(true);
    };

    return (
        <section className={styles.sourceMaterialsCard}>
            <div className={styles.sourceMaterialsMain}>
                <p className={styles.cardEyebrow}>Source Materials</p>
                <p className={styles.cardStatus}>
                    {count} document{count === 1 ? '' : 's'} available
                </p>
                {count > 0 ? (
                    <p className={styles.sourceMaterialsFiles}>{previewNames}</p>
                ) : (
                    <p className={styles.cardDescription} title={OVERVIEW_DUMMY_FIELDS.sourceMaterialsFallback}>
                        Upload initial project documents during setup to populate this list.
                    </p>
                )}
            </div>
            {count > 0 ? (
                <div className={styles.sourceMaterialsAction}>
                    <OverviewTextAction onClick={() => setListOpen(true)}>View files →</OverviewTextAction>
                </div>
            ) : null}

            <OverlayDrawer
                position="end"
                open={listOpen}
                size="medium"
                onOpenChange={(_, state) => setListOpen(state.open)}>
                <div className={styles.sourceDrawer}>
                    <header className={styles.sourceDrawerHeader}>
                        <div>
                            <p className={styles.cardEyebrow}>Source Materials</p>
                            <h2 className={styles.sourceDrawerTitle}>
                                {count} document{count === 1 ? '' : 's'}
                            </h2>
                        </div>
                        <button type="button" className={styles.sourceDrawerClose} onClick={() => setListOpen(false)} aria-label="Close">
                            <Dismiss20Regular />
                        </button>
                    </header>
                    <ul className={styles.sourceDrawerList}>
                        {files.map((file, index) => (
                            <li key={file.id || index}>
                                <button type="button" className={styles.sourceDrawerFile} onClick={() => openFile(file, index)}>
                                    {file.document_name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </OverlayDrawer>

            <FileViewerModal
                openModal={viewerOpen}
                setOpenModal={setViewerOpen}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                folderFiles={files.map(file => ({
                    id: file.id,
                    document_name: file.document_name,
                    document: file.document,
                    extension: file.extension,
                    filePath: file.document_name,
                }))}
                selectedFileIndex={selectedFileIndex}
                setSelectedFileIndex={setSelectedFileIndex}
            />
        </section>
    );
};

export default SourceMaterialsCard;
